import {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import {navigationTree, selectTree, urlProject, cleanTreeChilds, treeDe, treeFt} from "../actions/proyects.actions";
import {SelectedDateFn} from '../actions/auth.action';
import {alpha, makeStyles, withStyles} from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import {Link} from "react-router-dom";
import subprojectIcon from "../assets/img/icons/subproject.png";
import projectIcon from "../assets/img/icons/project.png";

// import { useSpring, animated } from 'react-spring/web.cjs'; // web.cjs is required for IE 11 support
import {useSelector, useDispatch} from "react-redux";

function MinusSquare(props) {
	return (
		<div className="d-flex" {...props}>
			<ion-icon name="chevron-down-outline"></ion-icon>
			<img
				src={projectIcon}
				alt="icons"
				width="15"
				style={{marginRight: 8}}
			/>
		</div>
	);
}

function PlusSquare(props) {
	return (
		<div className="d-flex" {...props}>
			<ion-icon name="chevron-forward-outline"></ion-icon>
			<img
				src={projectIcon}
				alt="icons"
				width="15"
				style={{marginRight: 8}}
				{...props}
			/>
		</div>
	);
}

function CloseSquare(props) {
	return (
		<img
			src={subprojectIcon}
			width="15"
			alt="icons"
			style={{marginRight: 8}}
			{...props}
		/>
	);
}

const StyledTreeItem = withStyles((theme) => ({
	iconContainer: {
		"& .close": {
			opacity: 0.3,
		},
	},
	group: {
		marginLeft: 7,
		paddingLeft: 18,
		borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
	},
}))((props) => <TreeItem {...props} />);

const useStyles = makeStyles({
	root: {
		height: 264,
		flexGrow: 1,
		maxWidth: 400,
	},
});

const Tree = ({levelStart, nodeSelected, saveSelecteds = true, resetDate = true}) => {
	
	const classes = useStyles();
	const dispatch = useDispatch();

	const [allLevels, setAllLevels] = useState(null);
	const [lastLevel, setLastLevel] = useState(0);
	const [loading, setLoading] = useState(true);
	const proyects = useSelector((state) => state.proyects);
	// const myTree = useSelector((state) => state.proyects.TreeProyects);
	// const [refreshTree, setRefreshTree] = useState(null);
	
	const [treeData, setTreeData] = useState([])
	const [search, setSearch] = useState()
	const [searchRegex, setSearchRegex] = useState()

  	const hasNavigated = useRef(false);

	useEffect(() => {
	// 	async function init() {
	// 		if ( proyects.TreeProyects.length > 0) {
	// 			setLoading(false);
	// 		}else{
				// dispatch(treeProject(setLoading))
	// 			setLoading(false);
	// 		}
	// 	}
		
	// 	init();
	// eslint-disable-next-line
	}, [nodeSelected]);

	// lo pasa a diccionario donde sus keys es el nivel
	const orderTree = () => {
		const tree = proyects.TreeProyects;
		let orderedLevels = {};

		for (let i = 0; i < tree.length; i++) {
			const item = tree[i];
			if (item.Nivel >= levelStart) {
				if (!orderedLevels[item.Nivel]) 
					orderedLevels[item.Nivel] = [];
				if (item.Nivel > lastLevel) 
					setLastLevel(item.Nivel);
				if (nodeSelected && nodeSelected.startsWith(item.CodProyecto)) {
					dispatch(selectTree(item.CodProyecto, true));
				}
				orderedLevels[item.Nivel].push({
					searchMatch: false,
					hidden: false,
					...item,
				});
			}
		}
		
		setAllLevels(orderedLevels);
		return orderedLevels;
	};
	// toma el diccionario y lo ordena usando el nivel como referencia
	const orderAllElements = (level = 1, parent = null, data = null) => {
		const allLevels2 = data ? data : allLevels;
		if( !allLevels2 || !allLevels2[level]) return null;
		const nextLevel = level + 1;

		return allLevels2[level]
				.filter(
					(item) =>
						parent === null || item.PhantomParentId === parent.CodProyecto || item.PhantomParentId === parent.CodClasificacion
				)
				.map((filter) => {
					filter['breadcrumbs'] = `${parent !== null ? parent.breadcrumbs + ' / ' : '' }${filter.Descripcion}`;
					// filter['prevParents'] = parent ? [...parent.prevParents, filter.CodProyecto] : [filter.CodProyecto];
					filter.changeParent = parent 
						? () =>{ 
							filter.hidden = false;
							parent.changeParent();
						} 
						: () => {
							filter.hidden = false;
						};
					if ( search === undefined || search === null || search === '' ) {
						filter['hidden'] = false;
					} else {
						const descriptionLower = filter.Descripcion.toLowerCase();
						if (  descriptionLower.includes(search.toLowerCase()) || (searchRegex !== '' && descriptionLower.match(searchRegex)) ) {
							filter.searchMatch = true;
							filter.changeParent();
						} else {
							filter['hidden'] = true;
						}
					}
					filter['items'] = orderAllElements(nextLevel, filter);
					return filter;
				});
	}

	useEffect(() => {
		if (proyects.TreeProyectsReady) {
		const ordered = orderTree(); // construye los niveles
		setAllLevels(ordered);
		const newTreeData = orderAllElements(1, null, ordered);
		setTreeData(newTreeData);
		setLoading(false);
		}
		// eslint-disable-next-line
	}, [proyects.TreeProyectsReady]);

	useEffect(() => {
		if (proyects.TreeProyectsReady && allLevels) {
		if (search && search.includes(' ')) {
			const myRegex = `(?=.*${search.toLowerCase().replaceAll(' ', ')(?=.*')})`;
			setSearchRegex(new RegExp(myRegex));
		} else {
			setSearchRegex('');
		}
		setTreeData(orderAllElements(1, null, allLevels));
		}
		// eslint-disable-next-line
	}, [search, allLevels]);
	

	useEffect(() => {
		if (!proyects.TreeProyectsReady || loading || !treeData.length) return;
		if (!nodeSelected || hasNavigated.current) return;

		// Función recursiva para encontrar el nodo en el árbol
		const findNode = (nodes, targetCode) => {
		for (let node of nodes) {
			if (node.CodProyecto === targetCode) {
			return node;
			}
			if (node.items) {
			const found = findNode(node.items, targetCode);
			if (found) return found;
			}
		}
		return null;
		};

		const targetNode = findNode(treeData, nodeSelected);
		if (targetNode && targetNode.breadcrumbs) {
		hasNavigated.current = true;
		dispatch(navigationTree(targetNode.breadcrumbs));
		}
	}, [proyects.TreeProyectsReady, loading, treeData, nodeSelected, dispatch]);

	const drawerItems2 = (level = 1, items) => {
		if (!items) return null;
		return items.map((item) => {
		if (level === lastLevel) {
			return (
			<Link
				to={item.CodProyecto ? `/projects/${item.CodProyecto}` : undefined}
				onClick={() => {
				if (!item.CodProyecto) return;
				dispatch(urlProject(`/projects/${item.CodProyecto}`));
				dispatch(SelectedDateFn(''));
				if (nodeSelected !== item.CodProyecto) {
					if (resetDate) localStorage.setItem('date-project', '');
					dispatch(cleanTreeChilds());
					dispatch(treeDe(item.CodProyecto));
					dispatch(treeFt(item.CodProyecto));
					localStorage.setItem('header-project', item.breadcrumbs);
					dispatch(navigationTree(item.breadcrumbs));
				}
				}}
				key={item.CodProyecto || item.CodClasificacion}
				style={{ background: "#000" }}
			>
				<StyledTreeItem
				nodeId={item.CodProyecto || item.CodClasificacion}
				label={item.Descripcion}
				/>
			</Link>
			);
		} else {
			return (
			<StyledTreeItem
				nodeId={item.CodProyecto || item.CodClasificacion}
				label={item.Descripcion}
				key={item.CodProyecto || item.CodClasificacion}
				hidden={item.hidden}
				onIconClick={() => {
				if (saveSelecteds) dispatch(selectTree(item.CodProyecto || item.CodClasificacion));
				}}
			>
				{drawerItems2(level + 1, item.items)}
			</StyledTreeItem>
			);
		}
		});
	};



	return (
		<>
			<div className="input-group mb-2">
				<div className="input-group-prepend">
					<div className="input-group-text" id="btnGroupAddon">
						<i className="fas fa-search"></i>
					</div>
				</div>
				<input
					type="search"
					className="form-control"
					placeholder="Buscador..."
					aria-label="Input group example"
					aria-describedby="btnGroupAddon"
					onChange={({target}) => setSearch(target.value)}
				/>
			</div>
			<TreeView
				className={classes.root}
				defaultExpanded={["1"]}
				defaultCollapseIcon={<MinusSquare />}
				defaultExpandIcon={<PlusSquare />}
				defaultEndIcon={<CloseSquare />}
				expanded={proyects.treeSelecteds}
				// className="mb-5"
				selected={proyects.idCard}
			>
				{loading ? "Cargando..." : drawerItems2(levelStart, treeData)}
				{/* {loading ? "Cargando..." : drawerItems(1)} */}
			</TreeView>
		</>
	);
};

Tree.propTypes = {
	levelStart: PropTypes.number,
};

export default Tree;
